<template lang="pug">
  .user-list-of-having-agency-archive
    v-autocomplete.nowrap(
      v-model="lazyValue"
      multiple
      clearable
      attach
      outlined
      item-value="id"
      item-text="name"
      :items="lazyUsers"
      :label="$t($lang.user.CREATOR)"
      :search-input.sync="search"
      @change="clearSearch"
    )
</template>

<script>
import { useAutocomplete, useSelectedSorter } from '@/helpers/misc';
import { useModelAutoBinding } from '@/helpers/misc/binding';
import { filterSelectedValues } from '@/helpers/content';
import { getActiveUsersOfAgencyArchive } from '@/api/agency-archive/AgencyArchiveApi';

export default {
  name: 'UserListOfHavingAgencyArchive',
  props: {
    value: {
      type: Array,
    },
  },
  setup(props, { emit }) {
    const { lazyValue } = useModelAutoBinding(emit, props, []);
    const [lazyItems, search, clearSearch] = useAutocomplete(getActiveUsersOfAgencyArchive);
    const [lazyUsers] = useSelectedSorter(lazyItems, lazyValue, filterSelectedValues, 'id');

    return {
      lazyValue,
      lazyUsers,
      search,
      clearSearch,
    };
  },
};
</script>
